import {
  ModalOverlay,
  ModalOverlayProps,
  Modal as AriaModal,
  composeRenderProps,
} from 'react-aria-components';
import { tv } from 'tailwind-variants';

import type { Size } from 'src/types/common';

export const overlayStyles = tv({
  base: 'fixed inset-0 isolate z-[100] flex items-center justify-center p-4',
  variants: {
    isEntering: {
      true: 'animate-in fade-in duration-200 ease-out',
    },
    isExiting: {
      true: 'animate-out fade-out duration-200 ease-in',
    },
    backdropBlur: {
      true: 'bg-overlay backdrop-blur-lg',
    },
  },
});

const modalStyles = tv({
  base: 'w-full max-h-[calc(var(--visual-viewport-height)-2rem)] rounded-2xl bg-surface-alt shadow-3',
  variants: {
    isEntering: {
      true: 'animate-in zoom-in-105 ease-out duration-200',
    },
    isExiting: {
      true: 'animate-out zoom-out-95 ease-in duration-200',
    },
    size: {
      small: 'max-w-90',
      medium: 'max-w-[47.5rem]',
    },
  },
});

export interface ModalProps extends ModalOverlayProps {
  size?: Size;
  backdropBlur?: boolean;
}

const Modal = ({
  size = 'medium',
  backdropBlur = true,
  className,
  ...props
}: ModalProps) => {
  return (
    <ModalOverlay
      {...props}
      className={(renderProps) =>
        overlayStyles({
          ...renderProps,
          backdropBlur,
        })
      }
    >
      <AriaModal
        {...props}
        className={composeRenderProps(className, (cn, renderProps) =>
          modalStyles({ ...renderProps, className: cn, size })
        )}
      />
    </ModalOverlay>
  );
};

export default Modal;
